import { lazy } from "react";

import { app } from "~/helpers/routes";
import { paths } from "~/router/paths";

const ContentHumanizerPage = lazy(() => import("~/pages/content/index"));

export const routes: Array<any> = [
  {
    path: paths.content.index,
    element: app(ContentHumanizerPage),
  },
];
